<!-- ── Toolbar: search + filter + download + actions ─────────────────────── -->
<div class="list-aliases__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'knowledge_base.aliases.search_placeholder' | translate"
    class="list-aliases__search"
  >
  </ui-form-field>
  <div class="filter-button-group">
    <button class="action-button" (click)="setFilter()" [ngClass]="{ activeFilter: hasActiveFilters() }">
      <div class="action-button-icon">
        <img src="assets/icones/filter_icon.svg" alt="" />
      </div>
      <span class="action-button-text">{{ "knowledge_base.filter" | translate }}</span>
      <div class="clear-icon-container">
        <img
          class="clear-icon"
          *ngIf="hasActiveFilters()"
          (click)="clearFilter(); $event.stopPropagation()"
          src="assets/icones/clear-icon.svg"
          alt=""
        />
        <div class="clear-tooltip" *ngIf="hasActiveFilters()">
          {{ "common.clear_filters" | translate }}
        </div>
      </div>
    </button>
  </div>
  <ui-button [label]="'knowledge_base.download' | translate" type="secondary" icon="download_icon" (click)="exportList()"> </ui-button>
  <div class="list-aliases__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary-text-outlined"
      icon="plus-cc"
      iconSize="large"
      [label]="'knowledge_base.aliases.add_alias' | translate"
      (click)="openCreateDialog()"
    >
    </ui-button>
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary"
      icon="upload"
      [label]="'knowledge_base.upload_file' | translate"
      (click)="openImportDialog()"
    >
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-aliases__table" [class.list-aliases__table--with-bulk-bar]="selection.hasSelection">
  <!-- Header -->
  <div class="list-aliases__table-header">
    <div class="list-aliases__table-cell list-aliases__table-cell--checkbox" (click)="$event.stopPropagation()">
      <ui-checkbox
        [checked]="selection.isAllSelected"
        [indeterminate]="selection.isPartialSelected"
        [ariaLabel]="'common.select_all' | translate"
        (changed)="selection.toggleAll($event.checked)"
      ></ui-checkbox>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('product_name')">
      {{ "knowledge_base.aliases.col.product_name" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'product_name' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'product_name' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('sku')">
      {{ "knowledge_base.aliases.col.sku" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'sku' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'sku' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('alias_value')">
      {{ "knowledge_base.aliases.col.alias" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'alias_value' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'alias_value' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('alias_type')">
      {{ "knowledge_base.aliases.col.type" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'alias_type' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'alias_type' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('customer_name')">
      {{ "knowledge_base.aliases.col.customer" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'customer_name' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'customer_name' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('create_date')">
      {{ "knowledge_base.aliases.col.created_date" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'create_date' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'create_date' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-aliases__table-cell list-aliases__table-cell--sortable" (click)="onSort('source')">
      {{ "knowledge_base.aliases.col.source" | translate }}
      <div class="list-aliases__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'source' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'source' && sortMode === 'desc'"></span>
      </div>
    </div>
  </div>

  <!-- Scrollable body -->
  <div class="list-aliases__table-body">
    <!-- Loading state -->
    <div class="list-aliases__loading" *ngIf="loading$ | async">
      <div class="list-aliases__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(loading$ | async) && sortedAliases.length > 0">
      <div *ngFor="let alias of sortedAliases" class="list-aliases__table-row" (click)="openEditDialog(alias)">
        <div class="list-aliases__table-cell list-aliases__table-cell--checkbox" (click)="$event.stopPropagation()">
          <ui-checkbox
            [checked]="selection.isSelected(alias.id)"
            [ariaLabel]="'common.select' | translate"
            (changed)="selection.toggleOne(alias.id, $event.checked, $event)"
          ></ui-checkbox>
        </div>
        <div class="list-aliases__table-cell">
          <a
            *ngIf="alias.product_id"
            class="list-aliases__product-link"
            [routerLink]="['/inventory', alias.product_id]"
            target="_blank"
            (click)="$event.stopPropagation()"
          >
            {{ alias.product_name }}
          </a>
          <span *ngIf="!alias.product_id">--</span>
        </div>
        <div class="list-aliases__table-cell">
          <span class="list-aliases__sku">
            {{ alias.sku || "--" }}
            <mat-icon
              *ngIf="hasInvalidSku(alias)"
              class="list-aliases__sku-warning"
              [matTooltip]="'knowledge_base.aliases.sku_warning_tooltip' | translate"
              matTooltipPosition="above"
            >
              warning
            </mat-icon>
          </span>
        </div>
        <div class="list-aliases__table-cell">{{ alias.alias_value }}</div>
        <div class="list-aliases__table-cell">{{ alias.alias_type }}</div>
        <div class="list-aliases__table-cell">{{ alias.customer_name || "--" }}</div>
        <div class="list-aliases__table-cell">{{ alias.create_date ? (alias.create_date | date: "dd/MM/yyyy") : "--" }}</div>
        <div class="list-aliases__table-cell">
          <span class="list-aliases__source-badge list-aliases__source-badge--{{ alias.source }}">
            {{ "knowledge_base.aliases.source." + alias.source | translate }}
          </span>
        </div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div *ngIf="sortedAliases.length === 0 && !(loading$ | async)" class="list-aliases__empty">
      <ng-container *ngIf="!keyword">
        <img class="list-aliases__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.aliases.empty_state" | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="keyword">
        <img class="list-aliases__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.aliases.empty_state_search" | translate }}</h3>
      </ng-container>
    </div>
  </div>

  <!-- ───────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ───────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()"
  >
    <button
      *appHasPermission="{ module: 'knowledge_base', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()"
    >
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination
    *ngIf="sortedAliases.length > 0"
    class="list-aliases__pagination"
    [pagination]="metadata$ | async"
    (toPageEvent)="toPage($event)"
  ></app-pagination>
</div>
